import {getUserAuth} from 'common/src/modules/auth/auth.service';
import {AxiosRequestConfig} from 'axios';

const GUEST_TOKEN_KEY = 'x-guest-token';

export default function applyAuthorizationHeader(config: AxiosRequestConfig) {
  const {token, guestToken} = getUserAuth();

  if (token) {
    config.headers = {
      ...config.headers,
      Authorization: `Bearer ${token}`,
    };
  }

  if (guestToken) {
    config.headers = {
      ...config.headers,
      [GUEST_TOKEN_KEY]: guestToken,
    };
  }

  return config;
}
